define("shared/components/shared/profile-categorization/categorize-steps/persona", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if @businessModel.description}}
    <div class="tSC--result">
      <p class="u--text--light u--text--sm u--text--uppercase">{{@businessModel.name}}</p>
      <div class="u--row u--row--noCollapse">
        <div class="u--col__8">
          <p class="u--text--lg">{{@businessModel.persona_definition}}</p>
          <p class="u--m__b__0">{{t "profile_categorization.persona.examples.title"}}</p>
          <p class="u--m__b__0">{{@businessModel.example}}</p>
        </div>
        <div class="u--col__4">
          <div class="tSC--result__image">
            <figure class="o--mediaContainer">
              <img class="o--media" src={{@businessModel.imageUrl}} />
            </figure>
          </div>
        </div>
      </div>
    </div>
  {{else}}
    <div class="tSC--result">
      <p class="u--text--white u--text--sm u--text--uppercase">{{t "profile_categorization.persona.select_option"}}</p>
      <div class="u--row u--row--noCollapse">
        <div class="u--col__4">
          <div class="tSC--result__image"></div>
        </div>
        <div class="u--col__4">
          <div class="tSC--result__image"></div>
        </div>
        <div class="u--col__4">
          <div class="tSC--result__image"></div>
        </div>
      </div>
    </div>
  {{/if}}
  */
  {
    "id": "eJx44fuv",
    "block": "[[[41,[30,1,[\"description\"]],[[[1,\"  \"],[10,0],[14,0,\"tSC--result\"],[12],[1,\"\\n    \"],[10,2],[14,0,\"u--text--light u--text--sm u--text--uppercase\"],[12],[1,[30,1,[\"name\"]]],[13],[1,\"\\n    \"],[10,0],[14,0,\"u--row u--row--noCollapse\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"u--col__8\"],[12],[1,\"\\n        \"],[10,2],[14,0,\"u--text--lg\"],[12],[1,[30,1,[\"persona_definition\"]]],[13],[1,\"\\n        \"],[10,2],[14,0,\"u--m__b__0\"],[12],[1,[28,[35,1],[\"profile_categorization.persona.examples.title\"],null]],[13],[1,\"\\n        \"],[10,2],[14,0,\"u--m__b__0\"],[12],[1,[30,1,[\"example\"]]],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"u--col__4\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"tSC--result__image\"],[12],[1,\"\\n          \"],[10,\"figure\"],[14,0,\"o--mediaContainer\"],[12],[1,\"\\n            \"],[10,\"img\"],[14,0,\"o--media\"],[15,\"src\",[30,1,[\"imageUrl\"]]],[12],[13],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],[[[1,\"  \"],[10,0],[14,0,\"tSC--result\"],[12],[1,\"\\n    \"],[10,2],[14,0,\"u--text--white u--text--sm u--text--uppercase\"],[12],[1,[28,[35,1],[\"profile_categorization.persona.select_option\"],null]],[13],[1,\"\\n    \"],[10,0],[14,0,\"u--row u--row--noCollapse\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"u--col__4\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"tSC--result__image\"],[12],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"u--col__4\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"tSC--result__image\"],[12],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,0],[14,0,\"u--col__4\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"tSC--result__image\"],[12],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]]]],[\"@businessModel\"],false,[\"if\",\"t\"]]",
    "moduleName": "shared/components/shared/profile-categorization/categorize-steps/persona.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});